import { Component, DoCheck, OnDestroy } from '@angular/core';
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";

import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";

@Component({
  selector: 'app-variance-widget',
  templateUrl: './variance-widget.component.html',
  styleUrls: ['./variance-widget.component.css']
})
export class VarianceWidgetComponent extends MultiSourceMultiValueWidget implements DoCheck {
  public w: any;
  ranges: any[] = [];
  public pointA: SharedPoint;
  public pointB: SharedPoint;
  public variance: number;
  public variancePercent: number;
  public variancePercentU: number;

  ngDoCheck(){
  }

  override eventTypes: string[]; 
  override timeSeriesEvent(type: string, uri: string): void {
    
  }

  liveDataOnly(): boolean {
    return false;
  }
  
  widgetBeforeInit(): void {
    this.w = this.widget;
  }

  widgetAfterInit(): void {
  }

  widgetLiveDataLoaded(s: any) {

  }

  widgetDataLoadTimeout(){
    
  }

  override widgetDataLoadComplete(): void {
      
  }
  
  widgetDataLoaded(series: SharedSeries): void {
    if (series.index == 0){
      if ((<any>this.w).displayA == "Average"){
        const sum = series.values.reduce((a, b) => a + b.value, 0);
        const avg = (sum / series.values.length) || 0;
        this.pointA = {uri:series.uri, value:avg} as SharedPoint;
      }
      else if ((<any>this.w).displayA == "Maximum"){
        this.pointA = series.values.sort((a,b)=>b.value-a.value)[0];
      }
      else if ((<any>this.w).displayA == "Minimum"){
        var sorted = series.values.sort((a,b)=>b.value-a.value);
        this.pointA = sorted[sorted.length-1];
      }
      else if ((<any>this.w).displayA == "Change"){
        var first = series.values[0].value;
        var last = series.values[series.values.length-1].value;
        this.pointA = {uri:series.uri, value:(last-first)} as SharedPoint;
      }
      else /* assume latest */ {
        this.pointA = series.values[series.values.length-1];
      }
    }
    else {
      if ((<any>this.w).displayB == "Average"){
        const sum = series.values.reduce((a, b) => a + b.value, 0);
        const avg = (sum / series.values.length) || 0;
        this.pointB = {uri:series.uri, value:avg} as SharedPoint;
      }
      else if ((<any>this.w).displayB == "Maximum"){
        this.pointB = series.values.sort((a,b)=>b.value-a.value)[0];
      }
      else if ((<any>this.w).displayB == "Minimum"){
        var sorted = series.values.sort((a,b)=>b.value-a.value);
        this.pointB = sorted[sorted.length-1];
      }
      else if ((<any>this.w).displayB == "Change"){
        var first = series.values[0].value;
        var last = series.values[series.values.length-1].value;
        this.pointB = {uri:series.uri, value:(first-last)} as SharedPoint;
      }
      else /* assume latest */ {
        this.pointB = series.values[series.values.length-1];
      }
    }
    this.getVariance();
  }

  public getVariance() {
    if (this.pointA && this.pointB){
      this.variance = (Math.round((Number(this.pointB.value) -  Number(this.pointA.value)) * 100)) / 100;
      this.variancePercent = Math.round(Math.abs(((this.variance) / (this.w.max - this.w.min)) * 100));
      this.variancePercentU = 100 - this.variancePercent;
    } else {
      this.variance = NaN;
      this.variancePercent = 0;
      this.variancePercentU = 100;
    }
  }


  public refresh(){
    this.ngOnInit();
  }
}
